import React from 'react';
import { Component } from '../../../concepts/objects';

export interface ExportValue {
    readonly id: string;
    readonly value: any;
}

export type ExportBlock = ExportValue[][];

export const ExportValue = (id: string | string[], value: any): ExportValue =>
    ({ id: Array.isArray(id) ? id.join('/') : id, value: (value ?? '').toString().trim() });

export type ExportDimensionParams = Record<string, any>;
export type ExportDimensionUIProps = { item: ExportDimension, onEdit: ExportDimensionUICallback };
export type ExportDimensionUICallback = (update: ExportDimension) => void;
export type ExportDimensionUI = React.ComponentType<ExportDimensionUIProps>;

export interface ExportDimensionType {
    readonly id: string;
    readonly label: string;
    readonly description: string;
    readonly ui?: React.ComponentType<ExportDimensionUIProps>;
    createInstance(this: ExportDimensionType, params?: ExportDimensionParams): ExportDimension;
}

export const ExportDimensionType = (inst: ExportDimensionType) => inst;

export interface ExportDimension {
    readonly id: string;
    readonly type: ExportDimensionType;
    readonly params: ExportDimensionParams;
    readonly label: string;
    read(this: ExportDimension, rows: Component[]): ExportBlock;
}

export const ExportDimension = Object.assign((inst: ExportDimension) => inst, {
    update(original: ExportDimension, paramPatch: Partial<ExportDimensionParams>) {
        return { ...original, params: { ...(original.params ?? {}), ...paramPatch } };
    },
});
